import React from 'react'
import { StyledTextWrapper, StyledText } from './styles'
import { useTranslation } from '../../../context/translationProvider'
import useSlugs from '../../../hooks/useSlugs'
import Link from '../link'

const ResponsibleGamblingWarning = () => {
  const { translate } = useTranslation()
  const [responsibleGamingSlug] = useSlugs(['responsible-gaming'])

  return (
    <StyledTextWrapper>
      <Link 
        href={`/${responsibleGamingSlug}`} 
        target="_blank" 
      >
          <StyledText>
            {translate('register.topBanner.ageLimit')}
          </StyledText>
          <StyledText style={{
            textDecoration: 'underline',
          }}>
            {translate('register.topBanner.responsibleGambling')}
          </StyledText>
      </Link>
    </StyledTextWrapper>
  )
}

export { ResponsibleGamblingWarning }
